import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ModificarCesanteDTO, NuevoCesanteDTO } from "../models/clientesCesantes";
import exp from "constants";


const editarCesante = async (data: ModificarCesanteDTO) => {
    const nroOperacion = data?.numeroOperacion?.trim();
    const response: AxiosResponse = await axiosInstance.put(
        `siscred-api-maestros/v1/clientescesantes/actualizar/${nroOperacion}`,
        data
    );
    return response;
};

const crearCesante = async (data: NuevoCesanteDTO) => {
    const response: AxiosResponse = await axiosInstance.post(`siscred-api-maestros/v1/clientescesantes/crear`, data);
    return response;
};

const getCliente = async (nroOperacion: string) => {
    const response: AxiosResponse = await axiosInstance.get(`siscred-api-maestros/v1/clientescesantes/buscar`, {
        params: { nroOperacion: nroOperacion }
    });
    return response;
};

export {
    editarCesante, 
    crearCesante,
    getCliente
}
